import React, { FC } from 'react';
import { Route } from 'react-router-dom';
import { Redirect, Switch, useRouteMatch } from 'react-router';
import { PageNotFound } from '../../shop/PageNotFound';
import { LCProductDetailReadPage } from './product/read/LCProductDetailReadPage';
import { YourTitlesPage } from './yourtitles/YourTitlesPage';
import { LocalContentCollectionPage } from './collection/LocalContentCollectionPage';
import { LCProductDetailEditPage } from './product/edit/LCProductDetailEditPage';
import { LCProductDetailNewPage } from './product/create/LCProductDetailNewPage';
import { CheckRequiredSpoc, SpocRequiredFor } from '../../shared/common/CheckRequiredSpoc/CheckRequiredSpoc';
import { PerformersPage } from './performer/PerformersPage';

const LocalContentRouteSwitch: FC = () => {
    const { path, url } = useRouteMatch();

    return (
        <Switch>
            <Route exact path={path}>
                <Redirect to={`${url}/collection`} />
            </Route>
            <Route exact path={`${path}/products`}>
                <YourTitlesPage />
            </Route>
            <Route exact path={`${path}/products/new`}>
                <LCProductDetailNewPage />
            </Route>
            <Route exact path={`${path}/products/:id`}>
                <CheckRequiredSpoc type={SpocRequiredFor.LOCAL_CONTENT_PRODUCT}>
                    <LCProductDetailReadPage />
                </CheckRequiredSpoc>
            </Route>
            <Route exact path={`${path}/products/:id/edit`}>
                <CheckRequiredSpoc type={SpocRequiredFor.LOCAL_CONTENT_PRODUCT}>
                    <LCProductDetailEditPage />
                </CheckRequiredSpoc>
            </Route>
            <Route exact path={`${path}/performers`}>
                <PerformersPage />
            </Route>
            <Route exact path={`${path}/collection`}>
                <LocalContentCollectionPage />
            </Route>
            <Route>
                <PageNotFound />
            </Route>
        </Switch>
    );
};

export default LocalContentRouteSwitch;
